// extracted by mini-css-extract-plugin
module.exports = {"policyLinkContainer":"PoliciesTable_policyLinkContainer__2WCej","currencyContainer":"PoliciesTable_currencyContainer__2ugRP"};